import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface APIVersionResponse {
  apiVersion: string;
  appVersion: string;
  env: string;
}

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  getVersion(): Observable<APIVersionResponse> {
    return this.http.get<APIVersionResponse>(`${this.apiUrl}/api/version`);
  }
}
